import React from 'react';
import { Grid } from '@material-ui/core';

import { BaseSporCardProps } from '../supplier/Supplier.interface';
import RequesterDetailsFormCard from './cards/RequesterDetailsFormCard';
import SupplierDetailsFormCard from './cards/SupplierDetailsFormCard';
import OrderDetailsFormCard from './cards/OrderDetailsFormCard';
import PricingDetailsFormCard from './cards/PricingDetailsFormCard';

const PurchaseOrderForm: React.FC<BaseSporCardProps> = (
  props: BaseSporCardProps
) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <RequesterDetailsFormCard {...props} />
      </Grid>
      <Grid item xs={12}>
        <SupplierDetailsFormCard {...props} />
      </Grid>
      <Grid item xs={12}>
        <OrderDetailsFormCard {...props} />
      </Grid>
      <Grid item xs={12}>
        <PricingDetailsFormCard {...props} />
      </Grid>
    </Grid>
  );
};

export default PurchaseOrderForm;
